// Bounded-concurrency batch settle (§12.3). Runs every task, never short-
// circuits: collects each result or error so the caller can persist all success
// checkpoints and all error sidecars before blocking the next pass.

export type Settled<T> = { index: number; ok: true; value: T } | { index: number; ok: false; error: unknown };

export async function mapSettled<I, T>(items: I[], limit: number, fn: (item: I, index: number) => Promise<T>): Promise<Settled<T>[]> {
  const results: Settled<T>[] = new Array(items.length);
  let next = 0;
  const workers = Array.from({ length: Math.max(1, Math.min(limit, items.length)) }, async () => {
    for (;;) {
      const i = next++;
      if (i >= items.length) return;
      try {
        results[i] = { index: i, ok: true, value: await fn(items[i]!, i) };
      } catch (error) {
        results[i] = { index: i, ok: false, error };
      }
    }
  });
  await Promise.all(workers);
  return results;
}
